import styled from "styled-components";
// import Theme from "./Theme";

const SectionHeader = styled.h2`
padding: 10px;
font-size: 32px;
font-weight: 600;

@media (max-width: 726px){
    font-size: 22px;
}
`
export default SectionHeader